import { render, staticRenderFns } from "./WcLoader.vue?vue&type=template&id=332ce388&lang=pug&"
import script from "./WcLoader.vue?vue&type=script&lang=js&"
export * from "./WcLoader.vue?vue&type=script&lang=js&"
import style0 from "./WcLoader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports